import type { PhotoDetail } from '@/types/photo';

const decodedImages = new Map<string, Promise<string>>();
export function slideImageSource(photo: PhotoDetail): string {
  const source = photo.originalUrl || photo.image;
  if (photo.mediaType === 'video') return photo.image;
  // Keep mock/external images intact. NAS originals get a bounded JPEG display copy.
  return /\/api\/photos\/[^/]+\/original(?:\?.*)?$/.test(source)
    ? source.replace(/\/original(?:\?.*)?$/, '/slideshow') : source;
}

export function decodeSlideImage(src: string): Promise<string> {
  const cached = decodedImages.get(src);
  if (cached) return cached;
  const promise = new Promise<string>((resolve, reject) => {
    const image = new Image();
    image.decoding = 'async';
    image.onload = () => {
      const finish = () => { image.onload = null; image.onerror = null; resolve(src); };
      if (typeof image.decode === 'function') void image.decode().then(finish, () => reject(new Error('사진을 해독하지 못했습니다.')));
      else finish();
    };
    image.onerror = () => { image.onload = null; image.onerror = null; reject(new Error('사진을 불러오지 못했습니다.')); };
    image.src = src;
  });
  decodedImages.set(src, promise);
  // Only keep the current image and its immediate neighbours in our own cache.
  while (decodedImages.size > 4) decodedImages.delete(decodedImages.keys().next().value!);
  void promise.catch(() => { if (decodedImages.get(src) === promise) decodedImages.delete(src); });
  return promise;
}

export const SLIDE_EFFECTS = ['dissolve', 'glide', 'rise', 'zoom', 'float'] as const;
export type SlideEffect = typeof SLIDE_EFFECTS[number];
